import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ROUTES } from '@/constants/routes';
import { proofLoginHref, safeProofReturnTo } from '@/lib/utils/proof-return-to';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // For development with mock data, allow access without auth
  const isMockMode = !import.meta.env.VITE_SUPABASE_URL || import.meta.env.VITE_SUPABASE_URL.includes('placeholder');

  if (loading && !isMockMode) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#5ac59a] mx-auto"></div>
          <p className="mt-2 text-sm text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // In mock mode, allow access without authentication
  if (isMockMode) {
    return <>{children}</>;
  }

  if (!user) {
    const destination = safeProofReturnTo(`${location.pathname}${location.search}`);
    return <Navigate to={destination ? proofLoginHref(destination) : ROUTES.LOGIN} replace />;
  }

  return <>{children}</>;
}
